// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1EcsU","logo":"Home_logo__1YbrH","loginContainer":"Home_loginContainer__8Z7DT","anchor":"Home_anchor__1JM7t"};